import React from 'react';
import { Link } from 'react-router-dom';
import './AS9100Certificate.css';

const AS9100Certificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Quality Certification</div>
            <h1 className="page-title">AS 9100 Certificate</h1>
            <div className="page-text-content">
              <p>
                Hello Valued Visitors,
              </p>
              <p>
                As NQC (Nova Quality Certification Agency), we take pride in being a professional 
                service provider specializing in certification and documentation. We continue our 
                commitment to providing high-quality services, and today we aim to focus on one of 
                the services we offer: the AS 9100 Aerospace and Space Quality Management System 
                Certificate.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is AS 9100?</h2>
            <div className="page-text-content">
              <p>
                AS 9100 is an international standard for Quality Management Systems in the Aerospace, 
                Space, and Defense Industry. This standard aims to ensure high quality and reliability 
                in products and services, helping businesses gain customer satisfaction and trust.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should You Obtain an AS 9100 Certificate?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Quality and Reliability</h3>
                <p className="reason-description">
                  The AS 9100 Certificate proves that your business maximizes quality and reliability, 
                  building customer trust and demonstrating your commitment to excellence.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. Compliance and Prevention of Illegal Activities</h3>
                <p className="reason-description">
                  The AS 9100 Certificate ensures compliance with legal and ethical requirements, 
                  preventing illegal activities and regulatory issues.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. Market Access</h3>
                <p className="reason-description">
                  The AS 9100 Certificate demonstrates that you meet industry requirements, 
                  facilitating access to new markets and business growth.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Innovation and Continuous Improvement</h3>
                <p className="reason-description">
                  The AS 9100 Certificate encourages continuous improvement and innovation, helping 
                  you gain a competitive advantage in the aerospace industry.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Obtain an AS 9100 Certificate?</h2>
            <div className="page-text-content">
              <p>
                To obtain an AS 9100 Certificate, you need to review your quality management system 
                and align it with AS 9100 requirements. NQC (Nova Quality Certification Agency) guides 
                you through this process, offering customized solutions tailored to your business needs 
                and managing the certification process effectively.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), we offer high-quality certification services, 
                including AS 9100, with extensive experience in various fields. We provide customized 
                solutions tailored to your business needs and manage the certification process effectively 
                for you.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Final Words</h2>
            <div className="page-text-content">
              <p>
                The AS 9100 Certificate is of great importance for quality management in the aerospace 
                and space industry. As NQC (Nova Quality Certification Agency), we are proud to assist 
                your business in obtaining this prestigious certificate to strengthen your leadership and 
                gain a competitive advantage. Feel free to contact us for more information or to ask 
                any questions.
              </p>
              <p>
                If you have any questions or need more information about our certification services, 
                our expert team will be happy to assist you.
              </p>
              <p>
                Best regards!
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default AS9100Certificate;

